module.exports = __webpack_public_path__ + "img/sld_scb_18_t1_b1_green.ce73a433.svg";